import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import DocumentTemplateList from './DocumentTemplateList';
import DocumentTemplateForm from './DocumentTemplateForm';
import DocumentTemplateHistory from './DocumentTemplateHistory';

const DocumentTemplateManager = () => {
  const [showForm, setShowForm] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreate = () => {
    setSelectedTemplate(null);
    setShowForm(true);
  };

  const handleEdit = (template) => {
    setSelectedTemplate(template);
    setShowForm(true);
  };

  const handleViewHistory = (template) => {
    setSelectedTemplate(template);
    setShowHistory(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedTemplate(null);
  };

  const handleCloseHistory = () => {
    setShowHistory(false);
    setSelectedTemplate(null);
  };

  const handleSave = () => {
    // Refrescar lista
    setRefreshKey(prev => prev + 1);
  };

  return (
    <>
      <DocumentTemplateList
        key={refreshKey}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onViewHistory={handleViewHistory}
      />

      <AnimatePresence>
        {showForm && (
          <DocumentTemplateForm
            template={selectedTemplate}
            onClose={handleCloseForm}
            onSave={handleSave}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showHistory && selectedTemplate && (
          <DocumentTemplateHistory
            template={selectedTemplate}
            onClose={handleCloseHistory}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default DocumentTemplateManager;
